import type { AccountsV2Query } from "@/gql/graphql";
import type { Account } from "./AccountContext";

type AccountsV2Summary = AccountsV2Query["accountsV2"][number];

export const mapAccountSummary = (summary: AccountsV2Summary): Account => ({
  id: summary.cdhId,
  iamId: summary.id,
  companyName: summary.name,
  primary: summary.isPrimary,
});

export const mapAccountsV2 = (
  summaries: AccountsV2Query["accountsV2"]
): Account[] => summaries.map(mapAccountSummary);
